import React from 'react';
import { Phone, MessageSquare } from 'lucide-react';
import { CAMP_SEASON } from './summerCampContent';
export function SummerCampFinalCTA() {
  return <>
      {/* === FINAL CTA - CUSTOM (uses camp registration phone, not main phone) === */}
      <section className="relative py-24 overflow-hidden bg-ink" data-id="element-3178">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-charcoal transform skew-x-12 translate-x-20 opacity-50 pointer-events-none" data-id="element-3179" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-3180">
          <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-3181">
            Ready to Save a Summer Camp Spot?
          </h2>
          <p className="text-xl text-gray-warm mb-10 max-w-2xl mx-auto" data-id="element-3182">
            Give your child a structured, active and fun summer experience at
            Storm Taekwondo. Text or call Megan directly to reserve your week.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-3183">
            <a href={`tel:${CAMP_SEASON.registrationPhone}`} className="btn-primary w-full sm:w-auto" data-id="element-3184">
              <Phone className="w-5 h-5 mr-2" data-id="element-3185" />
              Call {CAMP_SEASON.registrationPhone}
            </a>
            <a href={`sms:${CAMP_SEASON.registrationPhone.replace(/-/g, '')}`} className="btn-outline border-gray-warm text-white hover:bg-white hover:text-ink w-full sm:w-auto" data-id="element-3186">
              <MessageSquare className="w-5 h-5 mr-2" data-id="element-3187" />
              Text To Register
            </a>
          </div>
          <p className="text-gray-warm text-sm mt-8" data-id="element-3188">
            Or email{' '}
            <a href={`mailto:${CAMP_SEASON.registrationEmail}`} className="text-storm-red hover:underline font-bold" data-id="element-3189">
              {CAMP_SEASON.registrationEmail}
            </a>
          </p>
        </div>
      </section>

      <div className="bg-ink py-6 text-center border-t border-charcoal" data-id="element-3190">
        <p className="text-gray-warm text-sm" data-id="element-3191">
          Serving Farmington Hills, Novi, Commerce, Livonia and nearby Southeast
          Michigan families.
        </p>
      </div>
    </>;
}